import { isExtraSmallWindows } from '../../common_components/functions';
import InfrastructureImg from '../images/infrastructure.png';
import CustomerRImg from '../images/customer_r.png';
import MonetizationImg from '../images/monetization.png';
import BmcImg from '../images/bmc.png';

const DELAYED_COLOR = '#ff7043';
const DEFAULT_BORDER_COLOR = '#BDBDBD';
const TO_START_COLOR = '#BDBDBD';
const IN_PROGRESS_COLOR = '#17AF5E';
const DEFINITION_COLOR = '#EA80FC';
const FUNCTIONAL_COLOR = '#00b8d4';
const FINISHED_COLOR = '#00b8d4';
const CRITICAL_WEEK_COLOR = '#CA0B00';
const BLACK = '#000';
const WHITE = '#fff';
const DEFAULT_FONT_COLOR = '#333';
const HIGHLIGHT_COLOR = '#ffca28'; // '#5d89be';//'#385272';  //'#ffca28';

const SMALL_FONT_SIZE = 10;
const REGULAR_FONT_SIZE = 12;
const CURRENT_MVP_FONT_SIZE = 65;
const REGULAR_NODE_SIZE = 20;
const CURRENT_MVP_NODE_SIZE = 90;
const CURRENT_MVP_FEATURE_FONT_SIZE = 28;
const REGULAR_LINKING_NODE_SIZE = 15;
const CURRENT_MVP_LINKING_NODE_SIZE = 25;

const SECTIONABLE_TYPES = {
  MVP: 'Mvp'
};

const STARTUP_SECTIONS = {
  INFRASTRUCTURE: 'infrSection',
  CUSTOMER_R: 'crSection',
  MONETIZATION: 'monSection'
};

const STARTUP_SECTION_ICON = {
  [STARTUP_SECTIONS.INFRASTRUCTURE]: 'fa fa-university',
  [STARTUP_SECTIONS.CUSTOMER_R]: 'fa fa-users',
  [STARTUP_SECTIONS.MONETIZATION]: 'fa fa-diamond'
};

const NETWORK_LAYERS = {
  PRODUCT: 'product',
  // BMC: "bmc",
  ...STARTUP_SECTIONS
};

const STARTUP_SECTIONS_ARRAY = Object.values(STARTUP_SECTIONS);

const PRODUCT_NODE_TYPES = {
  VALUE_PROPOSITION: 'valueProposition',
  MVP: 'mvp',
  MVP_FEATURE: 'mvpFeature',
  MVP_STARTUP_SECTION: 'mvpSection',
  PRODUCT_BMC: 'product_bmc'
};

const BMC_NODE_TYPES = {
  BMC: 'bmc'
};

const STARTUP_SECTIONS_NODE_TYPES = STARTUP_SECTIONS;

const STARTUP_SECTIONS_FEATURES_NODE_TYPES = {
  SECTION_FEATURE: 'sectionFeature'
};

const NODE_TYPES = {
  ...PRODUCT_NODE_TYPES,
  ...STARTUP_SECTIONS_NODE_TYPES,
  ...STARTUP_SECTIONS_FEATURES_NODE_TYPES,
  ...BMC_NODE_TYPES
};

const EDGE_TYPES = {
  BMC: 'bmc',
  VALUE_PROPOSITION: 'valueProposition',
  MVP: 'mvp',
  MVP_FEATURE: 'mvpFeatures',
  STARTUP_SECTION: 'startupSection',
  MVP_STARTUP_SECTION: 'mvpStartupSection',
  SECTION_FEATURE: 'sectionFeature',
  BMC_MAIN: 'bmcMain',
  CURRENT_MVP: 'currentMvp'
};

const VALUE_PROPOSITION_NODE_ID = '-1';

const NETWORK_OPTIONS = {
  interaction: {
    keyboard: false,
    navigationButtons: true,
    zoomView: isExtraSmallWindows()
  },
  physics: {
    maxVelocity: 15,
    minVelocity: 1.3,
    timestep: 1
  },
  nodes: {
    font: '15px RalewayRegular #333',
    shadow: {
      color: 'rgba(0,0,0,0.20)',
      size: 4,
      x: 1,
      y: 1
    }
  },
  edges: {
    shadow: {
      color: 'rgba(0,0,0,0.3)',
      size: 2,
      x: 1,
      y: 1
    },
    chosen: false
  },
  groups: {
    [NODE_TYPES.VALUE_PROPOSITION]: {
      shape: 'dot',
      color: {
        border: '#424242',
        background: 'white',
        highlight: {
          border: HIGHLIGHT_COLOR,
          background: HIGHLIGHT_COLOR
        }
      },
      font: {
        size: 18
      },
      borderWidth: 8,
      borderWidthSelected: 8,
      size: 10
    },
    [NODE_TYPES.MVP]: {
      shape: 'circle',
      color: {
        highlight: {
          border: HIGHLIGHT_COLOR,
          background: HIGHLIGHT_COLOR
        }
      },
      borderWidth: 5,
      shadow: {
        color: 'rgba(0,0,0,0.25)',
        size: 8,
        x: 1,
        y: 1
      }
    },
    [NODE_TYPES.MVP_FEATURE]: {
      shape: 'box',
      borderWidth: 2,
      margin: 5,
      shapeProperties: {
        borderRadius: 10
      },
      color: {
        highlight: {
          border: HIGHLIGHT_COLOR,
          background: HIGHLIGHT_COLOR
        }
      }
    },
    [NODE_TYPES.BMC]: {
      // shape: 'diamond',
      // color: {
      //     background: "black",
      //     border: "black",
      //     highlight: {
      //         border: HIGHLIGHT_COLOR,
      //         background: HIGHLIGHT_COLOR,
      //     },
      // },
      shape: 'circularImage',
      image: BmcImg,
      color: {
        background: 'white',
        highlight: {
          border: HIGHLIGHT_COLOR,
          background: HIGHLIGHT_COLOR
        }
      },
      borderWidth: 5,
      shadow: {
        color: 'rgba(0,0,0,0.25)',
        size: 8,
        x: 1,
        y: 1
      }
    },
    [NODE_TYPES.PRODUCT_BMC]: {
      // shape: 'diamond',
      // color: {
      //     background: "black",
      //     border: "black",
      //     highlight: {
      //         border: HIGHLIGHT_COLOR,
      //         background: HIGHLIGHT_COLOR,
      //     },
      // },
      shape: 'circularImage',
      image: BmcImg,
      color: {
        background: 'white',
        highlight: {
          border: HIGHLIGHT_COLOR,
          background: HIGHLIGHT_COLOR
        }
      },
      borderWidth: 5,
      shadow: {
        color: 'rgba(0,0,0,0.25)',
        size: 8,
        x: 1,
        y: 1
      }
    },
    [NODE_TYPES.INFRASTRUCTURE]: {
      shape: 'circularImage',
      image: InfrastructureImg,
      color: {
        background: 'white',
        highlight: {
          border: HIGHLIGHT_COLOR,
          background: HIGHLIGHT_COLOR
        }
      },
      borderWidth: 5,
      shadow: {
        color: 'rgba(0,0,0,0.25)',
        size: 8,
        x: 1,
        y: 1
      }
    },
    [NODE_TYPES.CUSTOMER_R]: {
      shape: 'circularImage',
      image: CustomerRImg,
      font: {
        size: 18
      },
      color: {
        background: 'white',
        highlight: {
          border: HIGHLIGHT_COLOR,
          background: HIGHLIGHT_COLOR
        }
      },
      borderWidth: 4,
      shadow: {
        color: 'rgba(0,0,0,0.25)',
        size: 8,
        x: 1,
        y: 1
      }
    },
    [NODE_TYPES.MONETIZATION]: {
      shape: 'circularImage',
      image: MonetizationImg,
      font: {
        size: 18
      },
      color: {
        background: 'white',
        highlight: {
          border: HIGHLIGHT_COLOR,
          background: HIGHLIGHT_COLOR
        }
      },
      borderWidth: 4,
      shadow: {
        color: 'rgba(0,0,0,0.25)',
        size: 8,
        x: 1,
        y: 1
      }
    },
    [NODE_TYPES.SECTION_FEATURE]: {
      shape: 'box',
      borderWidth: 2,
      margin: 5,
      shapeProperties: {
        borderRadius: 10
      },
      color: {
        highlight: {
          border: HIGHLIGHT_COLOR,
          background: HIGHLIGHT_COLOR
        }
      }
    }
  }
};

const MVPS_FEATURES_PRIORITIES = {
  NORMAL: 'low_priority',
  MEDIUM: 'medium_priority',
  HIGH: 'high_priority'
};

const MVPS_FEATURES_COMPLEXITIES = {
  NORMAL: 'low_complexity',
  MEDIUM: 'medium_complexity',
  HIGH: 'high_complexity'
};

const MVPS_FEATURES_STATUSES = {
  TO_START: 'to_start',
  DEFINITION: 'definition',
  IN_PROGRESS: 'in_progress',
  FUNCTIONAL: 'functional',
  DELAYED: 'delayed',
  CRITICAL_WEEK: 'critical_week',
  FINISHED: 'finished'
};

const MVPS_FEATURES_PRIORITIES_ARRAY = Object.values(MVPS_FEATURES_PRIORITIES);

const MVPS_FEATURES_COMPLEXITIES_ARRAY = Object.values(
  MVPS_FEATURES_COMPLEXITIES
);

const MVPS_FEATURES_STATUSES_ARRAY = Object.values(MVPS_FEATURES_STATUSES);

const STARTUP_SECTIONS_NODE_TYPES_ARRAY = Object.values(
  STARTUP_SECTIONS_NODE_TYPES
);

const STARTUP_SECTIONS_FEATURES_NODE_TYPES_ARRAY = Object.values(
  STARTUP_SECTIONS_FEATURES_NODE_TYPES
);

const PRODUCT_NODE_TYPES_ARRAY = Object.values(PRODUCT_NODE_TYPES);

const NETWORK_LAYERS_ARRAY = Object.values(NETWORK_LAYERS);

const BMC_NODE_TYPES_ARRAY = Object.values(BMC_NODE_TYPES);

export {
  NETWORK_OPTIONS,
  NODE_TYPES,
  EDGE_TYPES,
  VALUE_PROPOSITION_NODE_ID,
  REGULAR_FONT_SIZE,
  CURRENT_MVP_FONT_SIZE,
  DELAYED_COLOR,
  TO_START_COLOR,
  DEFINITION_COLOR,
  IN_PROGRESS_COLOR,
  STARTUP_SECTION_ICON,
  FUNCTIONAL_COLOR,
  FINISHED_COLOR,
  CRITICAL_WEEK_COLOR,
  BLACK,
  WHITE,
  MVPS_FEATURES_PRIORITIES,
  MVPS_FEATURES_COMPLEXITIES,
  MVPS_FEATURES_STATUSES,
  MVPS_FEATURES_PRIORITIES_ARRAY,
  MVPS_FEATURES_COMPLEXITIES_ARRAY,
  MVPS_FEATURES_STATUSES_ARRAY,
  STARTUP_SECTIONS_ARRAY,
  STARTUP_SECTIONS,
  SECTIONABLE_TYPES,
  STARTUP_SECTIONS_NODE_TYPES,
  STARTUP_SECTIONS_FEATURES_NODE_TYPES,
  STARTUP_SECTIONS_NODE_TYPES_ARRAY,
  STARTUP_SECTIONS_FEATURES_NODE_TYPES_ARRAY,
  PRODUCT_NODE_TYPES,
  PRODUCT_NODE_TYPES_ARRAY,
  SMALL_FONT_SIZE,
  NETWORK_LAYERS,
  NETWORK_LAYERS_ARRAY,
  BMC_NODE_TYPES_ARRAY,
  REGULAR_NODE_SIZE,
  CURRENT_MVP_NODE_SIZE,
  DEFAULT_BORDER_COLOR,
  CURRENT_MVP_FEATURE_FONT_SIZE,
  REGULAR_LINKING_NODE_SIZE,
  CURRENT_MVP_LINKING_NODE_SIZE
};
